/* Naht & Leinen – Exit-Intent-Vorteil für Besucher aus bezahlten Anzeigen.
   Zeigt das Popup höchstens 1× pro Sitzung, nur bei leerem Warenkorb, nie über dem Cookie-Banner.
   Auslöser: Desktop = Maus verlässt das Fenster oben (frühestens nach 8 s),
             Handy = nach 18 s Verweildauer und kurzem Zurückscrollen.
   Vorschau: ?nl_popup=beaubag|bunbag (zählt wie ein Anzeigen-Besuch und legt die Welt fest),
             zusätzlich &nl_popup_test=1 öffnet sofort und ignoriert die Sitzungssperre. */
(() => {
  const wurzel = document.getElementById('NlExit');
  if (!wurzel || wurzel.dataset.bereit) return;
  wurzel.dataset.bereit = '1';

  const S_PAID = 'nl_exit_paid';
  const S_WELT = 'nl_exit_welt';
  const S_GEZEIGT = 'nl_exit_gezeigt';
  const PAID_PARAMETER = ['utm_source', 'fbclid', 'gclid', 'ttclid', 'nl_popup'];
  const DESKTOP_WARTEN = 8000;
  const HANDY_WARTEN = 18000;
  const HANDY_ZURUECK = 120; // px, die nach oben gescrollt werden müssen

  const params = new URLSearchParams(location.search);
  const speicher = {
    lesen: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    schreiben: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) { /* privat */ } },
  };

  // 1) Kommt der Besuch aus einer Anzeige? (Merken für die ganze Sitzung)
  if (PAID_PARAMETER.some((p) => params.has(p))) speicher.schreiben(S_PAID, '1');
  const vorschauWelt = params.get('nl_popup');
  if (vorschauWelt === 'beaubag' || vorschauWelt === 'bunbag') speicher.schreiben(S_WELT, vorschauWelt);
  const test = params.get('nl_popup_test') === '1';

  const welt = (vorschauWelt && ['beaubag', 'bunbag'].includes(vorschauWelt)) ? vorschauWelt : wurzel.dataset.welt;
  if (!welt) return;
  if (!test && speicher.lesen(S_PAID) !== '1') return;
  if (!test && speicher.lesen(S_GEZEIGT) === '1') return;
  if (!test && wurzel.dataset.warenkorbLeer !== 'true') return;

  wurzel.querySelectorAll('[data-welt-inhalt]').forEach((el) => {
    el.hidden = el.dataset.weltInhalt !== welt;
  });

  const dialog = wurzel.querySelector('.nl-exit__dialog');
  dialog.setAttribute('aria-labelledby', `NlExit-Titel-${welt}`);
  const code = wurzel.dataset.code || 'NEU5';
  let offen = false;
  let ausgeloest = false;
  let vorherFokus = null;
  const start = Date.now();

  const melden = (name, daten) => {
    try { window.Shopify?.analytics?.publish?.(name, { welt, ...daten }); } catch (e) { /* egal */ }
  };

  const bannerOffen = () => {
    const b = document.getElementById('pandectes-banner');
    if (!b) return false;
    const cs = getComputedStyle(b);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0' && b.getBoundingClientRect().height > 0;
  };

  const warenkorbLeer = async () => {
    if (test) return true;
    try {
      const r = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { credentials: 'same-origin' });
      const c = await r.json();
      return c.item_count === 0;
    } catch (e) {
      return true;
    }
  };

  const fokussierbar = () => [...dialog.querySelectorAll('a[href], button:not([disabled])')]
    .filter((el) => !el.closest('[hidden]') && el.offsetParent !== null);

  const tasten = (e) => {
    if (e.key === 'Escape') { schliessen('esc'); return; }
    if (e.key !== 'Tab') return;
    const f = fokussierbar();
    if (!f.length) return;
    const erst = f[0];
    const letzt = f[f.length - 1];
    if (e.shiftKey && document.activeElement === erst) { e.preventDefault(); letzt.focus(); }
    else if (!e.shiftKey && document.activeElement === letzt) { e.preventDefault(); erst.focus(); }
  };

  function oeffnen() {
    if (offen) return;
    offen = true;
    speicher.schreiben(S_GEZEIGT, '1');
    vorherFokus = document.activeElement;
    wurzel.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => requestAnimationFrame(() => wurzel.classList.add('is-offen')));
    dialog.focus({ preventScroll: true });
    document.addEventListener('keydown', tasten);
    melden('nl_exit_popup_gezeigt', {});
  }

  function schliessen(grund) {
    if (!offen) return;
    offen = false;
    wurzel.classList.remove('is-offen');
    document.removeEventListener('keydown', tasten);
    document.documentElement.style.overflow = '';
    setTimeout(() => { wurzel.hidden = true; }, 260);
    if (vorherFokus && vorherFokus.focus) vorherFokus.focus({ preventScroll: true });
    melden('nl_exit_popup_zu', { grund });
  }

  async function ausloesen() {
    if (ausgeloest) return;
    ausgeloest = true;
    if (!(await warenkorbLeer())) return;
    if (bannerOffen()) {
      // Erst nach dem Cookie-Banner zeigen, nie darüber
      const bis = Date.now() + 60000;
      const t = setInterval(() => {
        if (!bannerOffen()) { clearInterval(t); oeffnen(); }
        else if (Date.now() > bis) clearInterval(t);
      }, 800);
      return;
    }
    oeffnen();
  }

  // 2) Auslöser
  if (test) {
    setTimeout(ausloesen, 600);
  } else if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseout', (e) => {
      if (e.relatedTarget || e.clientY > 0) return;
      if (Date.now() - start < DESKTOP_WARTEN) return;
      ausloesen();
    });
  } else {
    let tiefster = window.scrollY;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y > tiefster) { tiefster = y; return; }
      if (Date.now() - start >= HANDY_WARTEN && tiefster - y >= HANDY_ZURUECK) ausloesen();
    }, { passive: true });
  }

  // 3) Bedienung
  wurzel.querySelectorAll('[data-nl-exit-zu]').forEach((el) => el.addEventListener('click', () => schliessen('nein')));

  const status = (inhalt, el, fertig) => {
    el.innerHTML = inhalt;
    el.classList.toggle('is-fertig', !!fertig);
  };

  const codeAktivieren = () => fetch(`/discount/${encodeURIComponent(code)}`, { credentials: 'same-origin', redirect: 'follow' });

  // Welt Beaubag: Code speichern, dann zum Set in der gewählten Farbe
  const knopfBeau = wurzel.querySelector('[data-nl-exit-aktion="set"]');
  if (knopfBeau) {
    knopfBeau.addEventListener('click', async () => {
      const box = knopfBeau.closest('[data-welt-inhalt]').querySelector('.nl-exit__status');
      knopfBeau.setAttribute('aria-busy', 'true');
      const ziel = setZiel();
      melden('nl_exit_popup_klick', { aktion: 'set', ziel });
      try {
        const r = await codeAktivieren();
        if (!r.ok) throw new Error(r.status);
        status(`${haken()} Code ${code} ist im Warenkorb hinterlegt`, box, true);
        setTimeout(() => { location.href = ziel; }, 900);
      } catch (e) {
        location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(ziel)}`;
      }
    });
  }

  // Welt Bunbag: Code im Hintergrund aktivieren und kopieren, Seite bleibt
  const knopfBun = wurzel.querySelector('[data-nl-exit-aktion="code"]');
  if (knopfBun) {
    knopfBun.addEventListener('click', async () => {
      const box = knopfBun.closest('[data-welt-inhalt]').querySelector('.nl-exit__status');
      knopfBun.setAttribute('aria-busy', 'true');
      melden('nl_exit_popup_klick', { aktion: 'code' });
      let kopiert = false;
      try { await navigator.clipboard.writeText(code); kopiert = true; } catch (e) { /* ohne Zwischenablage */ }
      try { await codeAktivieren(); } catch (e) { /* Code bleibt per Hand nutzbar */ }
      knopfBun.removeAttribute('aria-busy');
      status(`${haken()} Code ${code} ist aktiv${kopiert ? ' und kopiert' : ''}. Die 5 % gehen an der Kasse ab.`, box, true);
      knopfBun.textContent = 'Weiter stöbern';
      knopfBun.dataset.nlExitAktion = 'fertig';
      knopfBun.addEventListener('click', () => schliessen('fertig'), { once: true });
    }, { once: true });
  }

  function haken() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px;vertical-align:-3px;margin-right:4px"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  }

  // Set-Variante passend zur aktuell gewählten Beaubag-Farbe (Produktseite), sonst Standard
  function setZiel() {
    const basis = wurzel.dataset.setUrl;
    let karte = {};
    try { karte = JSON.parse(document.getElementById('NlExit-Varianten')?.textContent || '{}'); } catch (e) { /* leer */ }
    const formId = document.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
    const gewaehlt = params.get('variant') || formId;
    const setId = (gewaehlt && karte[gewaehlt]) || wurzel.dataset.setStandard;
    return `${basis}?variant=${setId}`;
  }

  // Bild an die gewählte Farbe anpassen (nur Welt Beaubag)
  const bilder = (() => { try { return JSON.parse(document.getElementById('NlExit-Bilder')?.textContent || '{}'); } catch (e) { return {}; } })();
  const designAusSeite = () => {
    const sel = document.querySelector('form[action*="/cart/add"] [name="id"]')?.value || params.get('variant');
    return sel && bilder.varianten ? bilder.varianten[sel] : null;
  };
  const img = wurzel.querySelector('[data-welt-inhalt="beaubag"] .nl-exit__bild img');
  const d = designAusSeite();
  if (img && d && bilder.designs && bilder.designs[d]) img.src = bilder.designs[d];
})();
